export interface ProviderBookButtonForm {
  email: string
  timeSlot?: Date
}

export interface ProviderBookButtonFormDefault {
  email?: string
  timeSlot?: string
}

export enum Steps {
  TimeSlot = 'timeSlot',
  Email = 'email'
}
